import login from '@/views/login/index.vue';

export default [
  {
    path: '/login',
    name: 'login',
    component: login,
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/error-pages/404/index.vue'),
  },
  {
    path: '/500',
    name: '500',
    component: () => import('@/views/error-pages/500/index.vue'),
  },
  {
    path: '/logic',
    name: 'logic',
    component: () => import('@/views/logic/index.vue'),
    props(route) {
      return {
        code: route.query.code,
      };
    },
  },
];
